module.exports = __webpack_public_path__ + "img/231.4063aea2.png";